<app-collapse class="d-flex position-relative" [(state)]="state">

    <div ngProjectAs="trigger" class="process-trigger d-flex flex-row gap-1 font-size-08rm font-light text-single-line color--white-100 px-2" [tooltip]="'Processes'" [tooltip-placement]="'top'">
        <span>{{processJobs().length}}</span>
        <app-navigation-module-icon [module-id]="Navigation.ProcessRunner"/>
    </div>

    <div ngProjectAs="content" class="process-container bg--surface position-absolute border-all shadow-small" aria-live="polite">
        <div class="d-flex flex-column">
            @if(processJobs().length > 0){
                @for (process of processJobs(); track process.executionDetails.executionId) {
                    <app-process-toast [process]="process"/>
                }
            }
            @else {
                <div class="p-3">
                    <span class="text-single-line font-light fst-italic">No Processes currently running</span>
                </div>
            }
        </div>
    </div>

</app-collapse>